import React, {forwardRef} from 'react';

import image1 from './image1.jpg';
import image2 from './image2.jpg';
import image3 from './image3.jpg';
import image4 from './image4.jpg';
import image5 from './image5.jpg';

import Page from '../../components/page';
import PictureSlider from '../../components/picture-slider';

let pictures = [
    {
        source: image1,
        description: "Foto 1 © Elle Fleur"
    },
    {
        source: image2,
        description: "Foto 2 © Elle Fleur"
    },
    {
        source: image3,
        description: "Foto 3 © Elle Fleur"
    },
    {
        source: image4,
        description: "Foto 4 © Elle Fleur"
    },
    {
        source: image5,
        description: "Foto 5 © Elle Fleur"
    }
];

const Workshops = forwardRef((props, ref) => {
    return (<Page header="Workshops" ref={ref}>
    <PictureSlider items={pictures.map(p => {return { source: p.source, element: (<div className="sliding-picture-description">{p.description}</div>) }})} />
    </Page>);
});

export default Workshops;